import { render, staticRenderFns } from "./JustScanReport.vue?vue&type=template&id=6476424c"
import script from "./JustScanReport.vue?vue&type=script&lang=js"
export * from "./JustScanReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports